import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from 'react';
import { _getURL } from "@/api/index";
import Redux, { updatePath } from "@/action";
import _ from 'lodash';
import { BottomNavigation } from '@/components/common/navigation';
import Link from 'next/link';
import { pageLink } from '@/config/site';
import { PopularTyreBrands, TyreBrandList, RecommendedTyre } from '@/components/tyre';
import { _postURL } from '../api';
import { useRouter } from 'next/router';
import {  _getAllTyreBrandList, _getAllTyreTopList, _getPlacement } from '../../libraries/common';
import { Footer } from '../../components/common/footer';
import { HeaderBack } from '../../components/common/header';
import { AllMeta } from '@/components/common/meta';
import Head from 'next/head';
import { placementArea } from '../../config/site';
import { PlacementBanner } from '../../components/placement';
import { MyBody } from '../../components/body/body';
import { CustomLink } from '../../components/app/customLink';

const tyreFilterSizeSelect = [
    {name: '15"', value: "15", type: "size"},
    {name: '16"', value: "16", type: "size"},
    {name: '17"', value: "17", type: "size"},
    {name: '18"', value: "18", type: "size"},
]

const tyreFilterBodyTypeSelect = [
    {name: "Sedan", value: "sedan", type: "bodyType"},
    {name: "Hatchback", value: "hatchback", type: "bodyType"},
    {name: "MPV", value: "mpv", type: "bodyType"},
    {name: "SUV", value: "suv", type: "bodyType"},
]

export default function Index(props) {
    const { t, device, session } = props;
    const { store, dispatch } = Redux();
    const [loading, setLoading] = useState(true);
    const router = useRouter();

    useEffect(()=>{
        let isMounted = true; // Flag to track component mount status

        const fetchData = async() => {
            try{
                if(_.isEmpty(store?.path?.dataAllTyreBrandList)){
                    await _getAllTyreBrandList(dispatch);
                }
                if(store?.path?.dataAllTyreTopList == undefined){
                    await _getAllTyreTopList(dispatch);
                }
                if(store?.path?.dataPlacement == undefined){
                    await _getPlacement(dispatch)
                }
            } catch(error) {
                console.log(error)
            } finally {
                if (isMounted) {
                    // Only update state if the component is still mounted
                    setLoading(false);
                }
            }
        }

        fetchData()
        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    },[])

    const _handleClickBrandItemLink = async(value) =>{
        if(!_.isEmpty(value?.brand_custom_url)){
            router.push(pageLink.tyre.tyreMidUrl + value?.brand_custom_url);
        }
    }

    return (
        <>
            <AllMeta
                title={t('tyrePage_meta_title')}
                description={t('tyrePage_meta_description')}
                keyword={t('tyrePage_meta_keyword')}
            />
            <Head><title>{t('tyrePage_title')}</title></Head>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBack t={t} />
                }
                // navigationComponent={
                //     <BottomNavigation t={t} />
                // }
            >
                <>
                    <PopularTyreBrands data={store?.path?.dataAllTyreTopList?.brand ?? []} isSingleRow={true} t={t} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} isTyreDetail={false} />
                    <RecommendedTyre data={store?.path?.dataAllTyreTopList?.model ?? []} t={t} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} />
                    <div className='containerPadding'>
                        <img 
                            className="tyreSizeImage"
                            src={"/assets/images/look_for_your_size.png"}
                        />
                    </div>
                    <div className='containerPadding'>
                        <div className='vehiclePage_lookCar_titleRow'>
                            <p className='fontSize_16 fontWeight_bold'>
                                {t('look_for_your_tyre')}
                            </p>
                            <CustomLink 
                                href={pageLink.tyre.filter}
                            >
                                <div className='vehiclePage_lookCar_goFilterIcon cursorPointer'>
                                    <img 
                                        src={`/assets/images/right_circle_icon.svg`}
                                    />
                                </div>
                            </CustomLink>
                            {/* <Link href={pageLink.tyre.filter}>
                                <div className='vehiclePage_lookCar_goFilterIcon cursorPointer'>
                                    <img 
                                        src={`/assets/images/right_circle_icon.svg`}
                                    />
                                </div>
                            </Link> */}
                        </div>
                        <div className='vehiclePage_lookCar_body'>
                            {
                                _.reduce(tyreFilterSizeSelect, (result, value, key) => {
                                    result.push(
                                        <CustomLink 
                                            key={key} 
                                            href={`${pageLink.tyre.filterResult}?search_type=by_filter&rim_diameter=${value.value}`} 
                                        >
                                            <div  className='vehiclePage_lookCar_button cursorPointer'>
                                                <p className='fontSize_14 vehiclePage_lookCar_button_text'>
                                                    {value.name}
                                                </p>
                                            </div>
                                        </CustomLink>
                                        // <Link key={key} href={`${pageLink.tyre.filterResult}?search_type=by_filter&rim_diameter=${value.value}`}>
                                        //     <div  className='vehiclePage_lookCar_button cursorPointer'>
                                        //         <p className='fontSize_14 vehiclePage_lookCar_button_text'>
                                        //             {value.name}
                                        //         </p>
                                        //     </div>
                                        // </Link>
                                    )
                                    return result
                                },[])
                            }
                        </div>
                        <div className='vehiclePage_lookCar_body vehiclePage_lookCar_body2'>
                            {
                                _.reduce(tyreFilterBodyTypeSelect, (result, value, key) => {
                                    result.push(
                                        <CustomLink 
                                            key={key} 
                                            href={`${pageLink.tyre.filterResult}?search_type=by_filter&body_type=${value.value}`}
                                        >
                                            <div className='vehiclePage_lookCar_button cursorPointer'>
                                                <p className='fontSize_14 vehiclePage_lookCar_button_text'>
                                                    {value.name}
                                                </p>
                                            </div>
                                        </CustomLink>
                                        // <Link key={key} href={`${pageLink.tyre.filterResult}?search_type=by_filter&body_type=${value.value}`}>
                                        //     <div className='vehiclePage_lookCar_button cursorPointer'>
                                        //         <p className='fontSize_14 vehiclePage_lookCar_button_text'>
                                        //             {value.name}
                                        //         </p>
                                        //     </div>
                                        // </Link>
                                    )
                                    return result
                                },[])
                            }
                        </div>
                    </div>
                    <div className='mt_25'>
                        <PlacementBanner
                            // can't pass object because inside using memo
                            loading={store?.path?.dataPlacement == undefined ? true : false}
                            area={placementArea?.tyre_homePage} 
                            placement_id={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.placement_id}
                            type={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.type}
                            image_path={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.image_path}
                            url={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.url}
                            script={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.script}
                        />
                    </div>
                    <div className='vehiclePage_vehicle_brandlistMargin'>
                        <TyreBrandList data={store?.path?.dataAllTyreBrandList ?? []} handleClickBrandItem={_handleClickBrandItemLink} willForceRefresh={true} loading={loading} t={t} />
                    </div>
                </>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('tyrePage_meta_title')}
    //             description={t('tyrePage_meta_description')}
    //             keyword={t('tyrePage_meta_keyword')}
    //         />
    //         <Head><title>{t('tyrePage_title')}</title></Head>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer bodyContainerHasBottomNavigation'>
    //                 <HeaderBack t={t} />
    //                 <PopularTyreBrands data={store?.path?.dataAllTyreTopList?.brand ?? []} isSingleRow={true} t={t} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} isTyreDetail={false} />
    //                 <RecommendedTyre data={store?.path?.dataAllTyreTopList?.model ?? []} t={t} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} />
    //                 <div className='containerPadding'>
    //                     <img 
    //                         className="tyreSizeImage"
    //                         src={"/assets/images/look_for_your_size.png"}
    //                     />
    //                 </div>
    //                 <div className='containerPadding'>
    //                     <div className='vehiclePage_lookCar_titleRow'>
    //                         <p className='fontSize_16 fontWeight_bold'>
    //                             {t('look_for_your_tyre')}
    //                         </p>
    //                         <Link href={pageLink.tyre.filter}>
    //                             <div className='vehiclePage_lookCar_goFilterIcon cursorPointer'>
    //                                 <img 
    //                                     src={`/assets/images/right_circle_icon.svg`}
    //                                 />
    //                             </div>
    //                         </Link>
    //                     </div>
    //                     <div className='vehiclePage_lookCar_body'>
    //                         {
    //                             _.reduce(tyreFilterSizeSelect, (result, value, key) => {
    //                                 result.push(
    //                                     <Link key={key} href={`${pageLink.tyre.filterResult}?search_type=by_filter&rim_diameter=${value.value}`}>
    //                                         <div  className='vehiclePage_lookCar_button cursorPointer'>
    //                                             <p className='fontSize_14 vehiclePage_lookCar_button_text'>
    //                                                 {value.name}
    //                                             </p>
    //                                         </div>
    //                                     </Link>
    //                                 )
    //                                 return result
    //                             },[])
    //                         }
    //                     </div>
    //                     <div className='vehiclePage_lookCar_body vehiclePage_lookCar_body2'>
    //                         {
    //                             _.reduce(tyreFilterBodyTypeSelect, (result, value, key) => {
    //                                 result.push(
    //                                     <Link key={key} href={`${pageLink.tyre.filterResult}?search_type=by_filter&body_type=${value.value}`}>
    //                                         <div className='vehiclePage_lookCar_button cursorPointer'>
    //                                             <p className='fontSize_14 vehiclePage_lookCar_button_text'>
    //                                                 {value.name}
    //                                             </p>
    //                                         </div>
    //                                     </Link>
    //                                 )
    //                                 return result
    //                             },[])
    //                         }
    //                     </div>
    //                 </div>
    //                 <div className='mt_25'>
    //                     <PlacementBanner
    //                         // can't pass object because inside using memo
    //                         loading={store?.path?.dataPlacement == undefined ? true : false}
    //                         area={placementArea?.tyre_homePage} 
    //                         placement_id={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.placement_id}
    //                         type={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.type}
    //                         image_path={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.image_path}
    //                         url={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.url}
    //                         script={store?.path?.dataPlacement?.[placementArea?.tyre_homePage]?.script}
    //                     />
    //                 </div>
    //                 <div className='vehiclePage_vehicle_brandlistMargin'>
    //                     <TyreBrandList data={store?.path?.dataAllTyreBrandList ?? []} handleClickBrandItem={_handleClickBrandItemLink} willForceRefresh={true} loading={loading} t={t} />
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //             <BottomNavigation t={t} />
    //         </div>
    //     </>
    // )

}


export async function getStaticProps({ locale }) {
    return {
        props: {
        ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}